<template>
  <div class="sku-price">
    <div class="sku-price-type" v-if="sku.activity && sku.activity.discount">
      <div class="member-price">
        会员价: ¥
        <em>{{sku.activity.discount}}</em>
      </div>
      <div class="market-rebate">
        <div class="market-price">
          <del>¥{{sku.market_price}}</del>
        </div>
        <div class="sku-rebate">
          <sku-rebate :sku="sku"></sku-rebate>
        </div>
      </div>
    </div>
    <div class="sku-price-type" v-else-if="sku.equity && sku.equity.discount">
      <div class="member-price">
        会员价: ¥
        <em>{{sku.equity.discount}}</em>
      </div>
      <div class="market-rebate">
        <div class="market-price">
          <del>¥{{sku.market_price}}</del>
        </div>
        <div class="sku-rebate">
          <sku-rebate :sku="sku"></sku-rebate>
        </div>
      </div>
    </div>
    <div class="sku-price-type" v-else-if="sku.market_price">
      <div class="member-price">
        市场价: ¥
        <em>{{sku.market_price}}</em>
      </div>
      <div class="sku-rebate" v-if="sku.equity && sku.equity.discount">
        <sku-rebate-tips :text="sku.equity.discount"></sku-rebate-tips>
      </div>
    </div>
  </div>
</template>

<script>
import SkuRebateTips from './SkuRewardsTipsOrder'
import SkuRebate from './SkuRewardsTips'
export default {
  name: 'skuPrice',
  components: {
    SkuRebate,
    SkuRebateTips
  },
  props: {
    sku: {
      type: Object
    }
  }
}
</script>

<style lang="less" scoped>
.sku-price {
  margin-top: 0.2rem;
}
.sku-price-type {
  display: flex;
  flex-direction: column;
  .member-price {
    color: @price;
    font-size: @fz22;
    em {
      font-size: @fz32;
      font-weight: bold;
    }
  }
  .market-rebate {
    .flex-between;
    margin-top: 0.1rem;
  }
  .market-price {
    font-size: @fz22;
    color: @base;
    padding-top: 0.1rem;
  }
}
</style>
